import axios from '@/utils/request'
import config from '@/config'
//概况
export const getDealerGeneral = (params)=>{
  return axios.request({
     url: 'v1/dealer/general',
     method: 'get',
     params
   })
 };
// 获取经销商列表
export const getDealerList = (params)=>{
 return axios.request({
    url: 'v1/dealer', 
    method: 'get',
    params
  })
};
// 经销商列表导出
export const dealserListExport = (params)=>{
  return axios.request({
     url: 'v1/dealer/export',
     method: 'get',
     params
   })
  };
// 经销商列表导入模板
export const downloadDealerModel = (params)=>{
  return axios.request({
      url: 'v1/dealer/downloadDealerModel',
      method: 'get',
      params
    })
  };
// 批量导入门店
export const dealerImport = (data)=>{
  return config.baseUrl[process.env.VUE_APP_type]+'v1/dealer/import'
};  
// 获取经销商列表(选择)
export const getDealerListSelect = (params)=>{
  return axios.request({
     url: 'v1/dealer/select',
     method: 'get',
     params
   })
 };
//添加经销商
export const dealerAdd = (data)=>{
 return axios.request({
  url: 'v1/dealer',
  method: 'post',
  data
  })
};
// 获取经销商详情
export const getDealerMore = (id)=>{
  return axios.request({
     url: 'v1/dealer/detail/'+id,
     method: 'get'
  })
};
// 获取经销商审核详情
export const getExamineDetail = (id)=>{
  return axios.request({
     url: 'v1/dealer/examineDetail',
     method: 'get',
     params:{dealer_id:id}
  })
};


 // 修改经销商
export const dealerEdit = (id,data)=>{
  return axios.request({
     url: 'v1/dealer/'+id,
     method: 'PUT',
     data
  })
};
 // 删除经销商
export const dealerDel = (id)=>{
  return axios.request({
     url: 'v1/dealer/'+id,
     method: 'DELETE'
  })
};
 // 禁用启用经销商
 export const dealerEnable = (id)=>{
  return axios.request({
     url: 'v1/dealer/enable/'+id,
     method: 'POST'
  })
};

// 获取经销商级别列表
export const getDealerLevelList = (params)=>{
  return axios.request({
     url: 'v1/dealerLevel',
     method: 'get',
     params
   })
 };
//经销商级别详情
 export const getDealerLevelMore = (id)=>{
  return axios.request({
     url: 'v1/dealerLevel/detail/'+id,
     method: 'get'
   })
 };
 //添加经销商级别
 export const dealerLevelAdd = (data)=>{
  return axios.request({
   url: 'v1/dealerLevel',
   method: 'post',
   data
   })
 };
 // 修改经销商级别
export const dealerLevelEdit = (id,data)=>{
  return axios.request({
     url: 'v1/dealerLevel/'+id,
     method: 'PUT',
     data
  })
};
 // 当前级别
 export const getNowDealerLevel = ()=>{
  return axios.request({
     url: 'v1/dealerLevel/current',
     method: 'GET'
  })
};
 // 删除级别
 export const delLevel = (id)=>{
  return axios.request({
     url: 'v1/dealerLevel/'+id,
     method: 'DELETE'
  })
};

// 获取业务员列表
export const getClerkList = (params)=>{
  return axios.request({
     url: 'v1/dealerSale',
     method: 'get',
     params
   })
 };
//业务员详情
 export const getClerkMore = (id)=>{
  return axios.request({
     url: 'v1/dealerSale/detail/'+id,
     method: 'get'
   })
 };
 //添加业务员
 export const clerkAdd = (data)=>{
  return axios.request({
   url: 'v1/dealerSale',
   method: 'post',
   data
   })
 };
 // 修改业务员
export const clerkEdit = (id,data)=>{
  return axios.request({
     url: 'v1/dealerSale/'+id,
     method: 'PUT',
     data
  })
};
// 禁用启用业务员
export const clerkEnable = (id,data)=>{
  return axios.request({
     url: 'v1/dealerSale/enable/'+id,
     method: 'POST',
     data
  })
};
// 删除业务员
export const clerkDel = (id)=>{
  return axios.request({
     url: 'v1/dealerSale/'+id,
     method: 'DELETE'
  })
};

// 获取经销商审核列表
export const getDealerReviewList = (params)=>{
  return axios.request({
     url: 'v1/dealer/examine',
     method: 'get',
     params
   })
};
// 经销商审核
export const setDealerReview = (id,data)=>{
  return axios.request({
     url: 'v1/dealer/examine/'+id,
     method: 'POST',
     data
  })
};

//经销商结构树
export const getTree = ()=>{
  return axios.request({
     url: 'v1/dealer/tree',
     method: 'GET'
  })
};
// 经销商审核
export const setDealerTemplate = (data)=>{
  return axios.request({
     url: 'v1/dealer/setTemplate',
     method: 'POST',
     data
  })
};
// 生成邀请注册链接
export const getInviteRegistered = (data)=>{
  return axios.request({
     url:'v1/dealer/getInviteRegistered',
     method: 'POST',
     data
  })
};

// 经销商销售大区列表
export const getDealerSaleCat = (params)=>{
  return axios.request({
     url:'v2/dealerSaleCat',
     method: 'get',
     params
  })
};

// 销售大区列表
export const getSaleCat = (params)=>{
  return axios.request({
     url:'v2/dealerSaleCat/all',
     method: 'get',
     params
  })
};
// 添加销售区域
export const createDealerSaleCat = (data)=>{
  return axios.request({
     url:'v2/dealerSaleCat',
     method: 'POST',
     data
  })
};
 // 修改销售大区
 export const updateDealerSaleCat = (id,data)=>{
  return axios.request({
     url: 'v2/dealerSaleCat/'+id,
     method: 'PATCH',
     data
  })
};
 // 删除销售大区
 export const delDealerSaleCat = (id,data)=>{
  return axios.request({
     url: 'v2/dealerSaleCat/'+id,
     method: 'DELETE',
     data
  })
};

 // 经销商推广明细
 export const extensionList = (params)=>{
  return axios.request({
     url: 'v1/dealer/extensionList',
     method: 'get',
     params
  })
};

// 批量修改品牌
export const batchEditSubBrand = (data)=>{
  return axios.request({
     url:'v1/dealer/batchEditSubBrand',
     method: 'POST',
     data
  })
};

// 修改密码
export const changePassword = (data)=>{
  return axios.request({
     url:'v1/dealer/changePassword/'+data.dealer_id,
     method: 'POST',
     data
  })
};
// 经销商登录页模板设置
export const setDealerLoginTemplate = (data)=>{
  return axios.request({
     url: 'v1/dealer/setLoginTemplate',
     method: 'post',
     data
  })
};
// 经销商页模板获取
export const getDealerLoginTemplate= (params)=>{
  return axios.request({
     url: 'v1/dealer/getLoginTemplate',
     method: 'get',
     params
  })
};

/**
 * 
 * 模板设置v2.0
 */

// 保存经销商业务员首页模板
export const setDealerSaleTemplate = (data)=>{
  return axios.request({
     url: 'v1/dealerSale/setTemplate',
     method: 'POST',
     data
  })
};

// 经销商菜单数据获取
export const getDealerTemplateMenu = (params)=>{
  return axios.request({
    url: 'v2/dealer/menu',
    method: 'get',
    params
  })
};
// 经销商后台首页设置
export const setDealerTemplateMenu = (data)=>{
  return axios.request({
    url: 'v2/dealer/menuConfig',
    method: 'post',
    data
  })
};
// 经销商常用功能-添加获取菜单数据
export const getDealerUsedMenu = (params)=>{
  return axios.request({
    url: 'v2/dealer/menuListsOftenUse',
    method: 'get',
    params
  })
};
// 经销商常用功能获取
export const getDealerTemplateUsed = (params)=>{
  return axios.request({
    url: 'v2/dealer/oftenUseMenu',
    method: 'get',
    params
  })
};
// 经销商常用功能添加
export const setDealerTemplateUsed = (data)=>{
  return axios.request({
    url: 'v2/dealer/oftenUseMenu',
    method: 'post',
    data
  })
};

/**
 * 经销商业务员模板设置
 */

// 经销商业务员-菜单数据获取
export const getDealerSaleTemplateMenu = (params)=>{
  return axios.request({
    url: 'v2/dealerSale/menu',
    method: 'get',
    params
  })
};
// 经销商业务员-后台首页设置
export const setDealerSaleTemplateMenu = (data)=>{
  return axios.request({
    url: 'v2/dealerSale/menuConfig',
    method: 'post',
    data
  })
};
// 经销商业务员-常用功能-添加获取菜单数据
export const getDealerSaleUsedMenu = (params)=>{
  return axios.request({
    url: 'v2/dealerSale/menuListsOftenUse',
    method: 'get',
    params
  })
};
// 经销商业务员-常用功能获取
export const getDealerSaleTemplateUsed = (params)=>{
  return axios.request({
    url: 'v2/dealerSale/oftenUseMenu',
    method: 'get',
    params
  })
};
// 经销商业务员-常用功能添加
export const setDealerSaleTemplateUsed = (data)=>{
  return axios.request({
    url: 'v2/dealerSale/oftenUseMenu',
    method: 'post',
    data
  })
};
// 经销商-系统配置详情
export const getNowDealerSet = ()=>{
  return axios.request({
    url: 'v2/dealer/configDetail',
    method: 'get',
    
  })
};
// 经销商-系统配置保存
export const editset = (data)=>{
  return axios.request({
    url: 'v2/dealer/config',
    method: 'post',
    data
  })
};
// 经销商分类列表
export const getdealerClass = (params)=>{
  return axios.request({
    url: 'v2/dealerClassification',
    method: 'get',
    params
  })
};
// 经销商分类详情
export const getMoredealerClass = (id)=>{
  return axios.request({
    url: 'v2/dealerClassification/detail/'+id,
    method: 'get',
  })
};
// 经销商分类编辑
export const editealerClass = (params)=>{
  return axios.request({
    url: 'v2/dealerClassification/'+params.id,
    method: 'PATCH',
    params
  })
};
// 经销商分类新增
export const adddealerClass = (params)=>{
  return axios.request({
    url: 'v2/dealerClassification',
    method: 'post',
    params
  })
};
// 经销商分类删除
export const DeldealerClas = (params)=>{
  return axios.request({
    url: 'v2/dealerClassification/'+params.id,
    method: 'DELETE',
    params
  })
};
// 经销商批量修改分类
export const allDealerEditClass = (params)=>{
  return axios.request({
    url: 'v2/dealer/setDealerClassification',
    method: 'post',
    params
  })
};
// 经销商业务员修改密码
export const salechangePassword = (params)=>{
  return axios.request({
    url: 'v2/dealerSale/changePassword/'+params.id,
    method: 'post',
    params
  })
};
// 世界地区列表
export const getcountyArea = ()=>{
  return axios.request({
    url: 'v2/area',
    method: 'get',
  })
};

